import { carrierTypeConvert } from './convert'
import {
  carrierShareCarrierType,
  carrierShareParam
} from '@/api/modules/carrier.js'
import { goNewWindows } from '@/utils/goNewWin.js'
import { getCarrierInfoBrief } from './simplify/carrierInfoBrief'

const winParams =
  'height=900,width=1000,top=0,left=200,toolbar=no,menubar=no,scrollbars=no,resizable=no,location=no,status=no'

// 判断当前是否win
export const isWin = function () {
  if (window.vm.$route.meta.win) {
    return true
  } else {
    return false
  }
}

// 对win窗详情做统一处理
// 监测点详情  carrierName 可以不传递
export const carrierDetail = async function (
  carrierId,
  carrierName = '',
  carrierType
) {
  if (!carrierId || !carrierType) { return new Error($t('integration.parameter_verification_failed')) }
  const typeCode = carrierTypeConvert(carrierType).en_title
  if (
    (!sessionStorage.getItem('getCarrierStatus') &&
      !sessionStorage.getItem('getCarrierType')) ||
    sessionStorage.getItem('getCarrierType') == 'undefined'
  ) {
    const { result } = await carrierShareCarrierType({ typeCode })
    const { result: results } = await carrierShareParam({
      code: 'carrier_status_item',
      type: 0
    })
    sessionStorage.setItem('getCarrierStatus', JSON.stringify(results))
    sessionStorage.setItem('getCarrierType', JSON.stringify(result))
  }
  goNewWindows({
    path: '/newCarrierDetail',
    way: '_blank',
    query: {
      keycode: carrierName,
      type: carrierType,
      id: carrierId
    }
  })
}

// 传感器历史数据
export const sensorHistory = function (params) {
  console.log(JSON.stringify(params))

  // id, tag_id, probe_value, scopeName, carrierName, carrierId, carrierTypeId, sensorWay , probe
  const def = {
    sensorWay: 'bind'
  }
  const mergeParams = {
    ...def,
    ...params
  }
  goNewWindows({
    path: '/historyData',
    way: '_blank',
    query: mergeParams
  })
}

// 电子签名
export const signature = function (callback) {
  // 这里callback 会提供一个签名base64参数
  window.writeFn = callback
  const { href } = vm.$router.resolve({
    path: '/canvasName'
  })
  // 当前组件与win窗口的通讯方法
  // window.writeFn = this.$parent.writeFn;
  const openWindow = window.open(
    href,
    '_blank',
    'height=800,width=800,top=200,left=200,toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no'
  )
  openWindow.onload = () => {
    openWindow.document.title = $t('integration.electronic_signature_')
  }
}

// 平面图
export const plan = function () {
  // 平面图需要读取缓存中的参数
}

// 可追踪监测点的实时轨迹和历史轨迹
export const traceInfo = function (id) {
  const { href } = vm.$router.resolve({
    path: '/traceDetail',
    query: {
      id
    }
  })
  const openWindow = window.open(
    href,
    '_blank',
    'height=900,width=900,top=0,left=200,toolbar=no,menubar=no,scrollbars=no,resizable=no,location=no,status=no'
  )
  openWindow.onload = () => {
    openWindow.document.title = $t('integration.track_information')
  }
}
// 可追踪监测点历史轨迹
export const traceHistory = function (id) {
  const { href } = vm.$router.resolve({
    path: '/traceHistory',
    query: {
      id
    }
  })
  const openWindow = window.open(
    href,
    '_blank',
    'height=900,width=900,top=0,left=200,toolbar=no,menubar=no,scrollbars=no,resizable=no,location=no,status=no'
  )
  openWindow.onload = () => {
    openWindow.document.title = $t('integration.track_information')
  }
}

// 探头历史
/**
 *
 * @param {*} carrierId 监测点ID
 * @param {*} deviceCode code
 * @param {*} deviceName 设备名称
 * @param {*} deviceType 设备类型
 * @param {*} fullPath 全路径 可以不提供  不提供则使用接口获取
 */
export const probeHistory = function (
  carrierId,
  carrierName,
  carrierType,
  deviceCode,
  deviceName,
  deviceType,
  fullPath
) {
  const { href } = vm.$router.resolve({
    path: '/probeHistory',
    query: {
      carrierId,
      carrierName,
      carrierType,
      deviceCode,
      deviceName,
      deviceType,
      fullPath
    }
  })
  window.open(href, '_blank', winParams)
  // openWindow.onload = () => {
  //     openWindow.document.title = fullPath + ' ' + deviceName + $t('图表');
  // };
}

// 挂载探头历史 (多个探头)
export const sampleValueHistory = function ({
                                               carrierId,
                                               sceneId,
                                               carrierType,
                                               carrierName
                                             }) {

  const query = {
    carrierId,
    sceneId,
    carrierType,
    carrierName
  }

  const { href } = vm.$router.resolve({
    path: '/carrierProbeHistory',
    query: query
  })
  window.open(
    href,
    '_blank',
    'height=900,width=1200,top=0,left=200,toolbar=no,menubar=no,scrollbars=no,resizable=no,location=no,status=no'
  )
}

// 挂载探头历史 (多个探头)
export const carrierProbeHistory = function ({
  carrierId,
  type,
  description,
  carrierName,
  carrierInfo = {}
}) {
  if (!carrierInfo.id) {
    return
  }

  const query = {
    carrierId,
    type,
    description,
    carrierName
  }
  if (carrierInfo.id) {
    carrierInfo = getCarrierInfoBrief(carrierInfo)
  }
  console.log(carrierInfo)
  Object.keys(carrierInfo).forEach(key => {
    if (carrierInfo[key]) {
      query[key] = carrierInfo[key]
    }
  })

  const { href } = vm.$router.resolve({
    path: '/carrierProbeHistory',
    query: {
      carrierId,
      type,
      description,
      carrierName,
      ...carrierInfo
    }
  })
  window.open(
    href,
    '_blank',
    'height=900,width=1200,top=0,left=200,toolbar=no,menubar=no,scrollbars=no,resizable=no,location=no,status=no'
  )
}

export const transportHistory = function ({ carrierInfo }) {
  const query = {}

  if (carrierInfo.id) {
    carrierInfo = getCarrierInfoBrief(carrierInfo)
  }

  Object.keys(carrierInfo).forEach(key => {
    if (carrierInfo[key]) {
      query[key] = carrierInfo[key]
    }
  })
  const { href } = vm.$router.resolve({
    path: '/transHistory',
    query: carrierInfo
  })
  window.open(
    href,
    '_blank',
    'height=900,width=1400,top=0,left=200,toolbar=no,menubar=no,scrollbars=no,resizable=no,location=no,status=no'
  )
}

// 底座历史数据
export const baseHistory = function (baseNo) {
  const { href } = vm.$router.resolve({
    path: '/baseHistory',
    query: {
      baseNo
    }
  })
  const openWindow = window.open(href, '_blank', winParams)
  openWindow.onload = () => {
    openWindow.document.title = baseNo + $t('数据处理')
  }
}

// 报警记录
export const alarmRecord = function () {
  const { href } = vm.$router.resolve({
    path: '/alarmRecord'
  })
  const openWindow = window.open(href, '_blank', winParams)
  openWindow.onload = () => {
    openWindow.document.title = $t('报警记录')
  }
}

// 报警触发
export const alarmTrigger = function () {
  const { href } = vm.$router.resolve({
    path: '/sysAlarm'
  })
  const openWindow = window.open(
    href,
    '_blank',
    'height=900,width=1200,top=0,left=200,toolbar=no,menubar=no,scrollbars=no,resizable=no,location=no,status=no'
  )
  openWindow.onload = () => {
    openWindow.document.title = $t('business.alarm_trigger')
  }
}

// AT指令
export const atCommand = function (row) {
  const { name, mac, carrierName } = row
  const routeurl = vm.$router.resolve({
    path: '/atinstruction',
    query: {
      name,
      mac,
      carrierName
    }
  })
  const iWidth = 1280
  const iHeight = 700
  const iTop = (window.screen.height - 30 - iHeight) / 2 // 获得窗口的垂直位置;
  const iLeft = (window.screen.width - 10 - iWidth) / 2 // 获得窗口的水平位置;
  window.open(
    routeurl.href,
    'AT',
    `height=${iHeight},innerHeight=${iHeight},width=${iWidth},innerWidth=${iWidth},top=${iTop},left=${iLeft},toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no`
  )
}
